import { Box, Flex } from 'styled-system/jsx';
import RemoveIcon from '@/common/assets/icons/trash-icon-v2.svg?react';
import EditIcon from '@/common/assets/icons/edit-icon-v2.svg?react';
import InfoIcon from '@/common/assets/icons/infoCircleIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import BulletTypography from '@/common/components/base/typography/BulletTypography';
import React, { useCallback, useState } from 'react';
import { ISubstitutionPartsCard } from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/SubstitutionPartsCard/SubstitutionPartsCard.type';
import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import { token } from 'styled-system/tokens';

const SubstitutionPartsCard = React.memo<ISubstitutionPartsCard>(
  ({ data, editAble, index, edit, remove, id, caption, icon }) => {
    return (
      <Box boxShadow="cardShadow" bg="white" borderRadius={8} mb={16}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={16}
          py={12}
          borderBottom="1px solid"
          borderColor="gray-2"
        >
          <Box display="flex" alignItems="center" gap={8}>
            <Typography color="black-4" fontStyle="b3">
              {index + 1}
            </Typography>
            <Typography color="gray-2">|</Typography>
            {icon}
          </Box>
          {editAble && edit && remove && (
            <EditAbleSection edit={edit} remove={remove} id={id} />
          )}
        </Box>
        <Flex flexDirection="column" gap={16} px={16} py={12} mt={4}>
          {data?.map((item, index) => (
            <Flex
              key={index}
              alignItems="center"
              justifyContent="space-between"
            >
              <BulletTypography
                backgroundColor="purple-3"
                textStyle="b2"
                color="black-3"
              >
                {item?.name}
              </BulletTypography>
              <Typography textStyle="b2" color="black-1">
                {item?.value}
              </Typography>
            </Flex>
          ))}
          {caption && RenderCaption(caption)}
        </Flex>
      </Box>
    );
  },
);
export default SubstitutionPartsCard;

const RenderCaption = (caption: string) => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <MainModal open={openModal} closeModal={() => setOpenModal(false)}>
        <TitleDescription>توضیحات</TitleDescription>
        <Box
          bg="white"
          borderRadius={8}
          p={16}
          mt={24}
          boxShadow={token('shadows.cardShadow')}
        >
          <Typography textStyle="b2" color="black-1">
            {caption}
          </Typography>
        </Box>
      </MainModal>
      <Box
        display="flex"
        alignItems="center"
        gap={8}
        onClick={() => setOpenModal(true)}
      >
        <InfoIcon width={16} height={16} />
        <Typography color="purple-3" textStyle="b4">
          مشاهده توضیحات
        </Typography>
      </Box>
    </>
  );
};

const EditAbleSection = React.memo(
  ({
    edit,
    remove,
    id,
  }: {
    edit: (id: number) => void;
    remove: (id: number) => void;
    id: number;
  }) => {
    const handleEdit = useCallback(() => edit(id), [edit, id]);
    const handleRemove = useCallback(() => remove(id), [remove, id]);

    return (
      <Box display="flex" alignItems="center" gap={16}>
        <EditIcon onClick={handleEdit} />
        <RemoveIcon onClick={handleRemove} />
      </Box>
    );
  },
);
